import { ColorGenerator } from '../color-generator/color-generator.class';

export class VarianceGraph {
    uid: number;
    name: string;
    staff: string;
    staffId: number;
    grossSales: string;
    itemsSold: string;
    net: string;
    vat: string;
    cost: string;
    discounts: string;
    revenueMargin: string;
    backgroundColor: string;
    model: boolean;
    class: string;
    type: string;
    productId: number;

  constructor(data: any) {
    if (data) {
        this.uid = Number(data.variance_uid);
        this.name = data.variance_name;
        this.staff = data.account_name;
        this.staffId = Number(data.account_uid);
        this.productId = Number(data.product_uid);
        this.grossSales = data.gross_sales;
        this.itemsSold = data.items_sold;
        this.net = data.net;
        this.vat = data.vat;
        this.cost = data.cost;
        this.discounts = data.discount;
        this.revenueMargin = data.revenue_margin;
        const n = Math.random().toString(36).substring(7);
        // const n = Math.round(Math.random() * 100);
        const randomString = this.name + ' ' + n;
        // const str = String(new ColorGenerator().BKDRHash(String(this.uid)) % 16777215);
        this.backgroundColor = new ColorGenerator().stringToColour(randomString);
        this.type = 'variance';
    }
  }
}
